import React, { PropsWithChildren } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import FHLink from "@components/SemanticTheme/FHLink";
import { useIsClient } from "src/hooks/hooks";

const useStyles = makeStyles((theme) => ({
  linkRoot: {
    fontSize: 24,
    fontFamily: theme.typography.h1.fontFamily,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
    "&:hover": {
      color: theme.palette.text.primary,
    },
  },
  actions: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      paddingTop: theme.spacing(2.4),
    },
    "& $linkRoot": {
      "& svg": {
        width: 24,
        height: 24,
        marginTop: 2,
      },
    },
  },
}));

type LayoutColumnSize = 1 | 2 | 6 | 3 | 4 | 5 | 7 | 8 | 9 | 10 | 11 | 12;

export type TwoColumnLayoutProps = {
  spacing?: number;
  className?: string;
  leftColumn?: React.ReactNode;
  rightColumn?: React.ReactNode;
  leftColumnSize?: LayoutColumnSize;
  rightColumnSize?: LayoutColumnSize;
  ctaUrl?: string;
  ctaTitle?: string;
};

export const TwoColumnLayout: React.FC<TwoColumnLayoutProps> = ({
  spacing,
  className,
  leftColumn,
  rightColumn,
  leftColumnSize = 6,
  rightColumnSize = 6,
  ctaUrl,
  ctaTitle,
}: PropsWithChildren<TwoColumnLayoutProps>) => {
  const classes = useStyles();
  const isClient = useIsClient();
  return (
    <Grid container spacing={spacing} className={className}>
      {leftColumn && (
        <Grid item xs={12} md={leftColumnSize}>
          {leftColumn}
          {ctaUrl && ctaTitle && rightColumn && isClient && (
            <div className={classes.actions}>
              <FHLink
                className={classes.linkRoot}
                URL={ctaUrl}
                title={ctaTitle}
                color="primary"
                hasDefaultIcon
                hasInlineIcon
                chevronRightRounded
              />
            </div>
          )}
        </Grid>
      )}

      {rightColumn && (
        <Grid item xs={12} md={rightColumnSize}>
          {rightColumn}
        </Grid>
      )}
    </Grid>
  );
};

export default TwoColumnLayout;
